import { render } from "./PreviewMode.vue?vue&type=template&id=49b98fe0&scoped=true&ts=true"
import script from "./PreviewMode.vue?vue&type=script&lang=ts"
export * from "./PreviewMode.vue?vue&type=script&lang=ts"

import "./PreviewMode.vue?vue&type=style&index=0&id=49b98fe0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b98fe0"]])

export default __exports__